// The text that scrolls across the top of the front page. Edit the string below.
// It loops forever, so the trailing space is the gap before it starts over.
// One copy has to be wider than the screen or blank space shows at the right while it scrolls,
// so the pattern is repeated; keep it at least this long if you change it.
export const TICKER_MESSAGE = '★ ♥ ☆ ♡ ✦ ❥ ✧ ❦ ✩ ✪ ♥ ✫ ♡ ✬ ❥ ✭ ❦ ✮ '.repeat(3);
